import { useState } from "react";
import MaterialTable from "@material-table/core";
import { resetOrdersPostData } from "./api";
import { log } from "../../Helper";
import { toast } from "react-toastify";
import useFilterState from "../../hooks/useFilterState";
import { Button } from "@deere/fuel-react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../load-build/utility/constants";
import _ from "lodash";

const ResetOrdersMaterialTable = (props) => {
  const { tableName, tableData, onPageChange, setIsLoading, getTableData } =
    props;
  const errorResetTable = "Error Alert Table";
  const columns = [
    {
      title: "Source",
      field: "src",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Number",
      field: "ordernumber",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "From To",
      field: "fromTo",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Status",
      field: "orderStatus",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Scenario ID",
      field: "scenarioId",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Created On",
      field: "createdAt",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "E Ship Date",
      field: "eshpDate",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Severity",
      field: "severity",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Error",
      field: "error",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Error Desc",
      field: "errorDesc",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Add Info",
      field: "addInfo",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Year",
      field: "orderYear",
      hidden: true,
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  const [selectedRowIds, setSelectedRowIds] = useState(new Set());

  const rowsChangeFunction = () => {
    setIsLoading(true);
    setInterval(() => setIsLoading(false), 100);
  };

  return (
    <ThemeProvider theme={theme}>
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: (
              <h6 className="mt-[-86%] top-[16%] text-center">
                No records to display
              </h6>
            ),
          },
          pagination: {
            labelRowsPerPage: "Orders Per Page",
            labelRowsSelect: "Orders",
          },
        }}
        options={{
          rowStyle: {
            fontSize: 10,
          },
          sorting: false,
          selection: true,
          search: false,
          filtering: true,
          showTitle: false,
          pageSize: 100,
          maxBodyHeight: 600,
          draggable: false,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "400",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            maxHeight: 600,
            overflow: "auto",
          },
          pageSizeOptions: [100, 500, 1000],
          filterCellStyle: {
            flex: 1
          },
        }}
        title={errorResetTable}
        columns={columnsWithFilter.map((col, index) => {
          if (
            col.tableData?.filterValue == "" ||
            col.tableData?.filterValue == null ||
            col.tableData?.filterValue == undefined
          ) {
            let colWithoutDefaultFilter = _.omit(
              col,
              "defaultFilter",
              "tableData.filterValue"
            );
            return colWithoutDefaultFilter;
          } else {
            return {
              ...col,
              defaultFilter: col.tableData?.filterValue,
            };
          }
        })}
        onSelectionChange={(selectedRows) => {
          const newSelectedIds = new Set(
            selectedRows.map((row) => row.src + '-' + row.ordernumber)
          );
          setSelectedRowIds(newSelectedIds);
        }}
        data={tableData.map((row) => ({
          ...row,
          tableData: {
            ...(row.tableData || {}),
            checked: selectedRowIds.has(row.src + '-' + row.ordernumber),
          },
        }))}
        onChangePage={(e) => onPageChange(e)}
        onFilterChange={(filters) => {
          // Create a map of current filters for quick lookup
          const filterMap = new Map();
          filters.forEach((filter) => {
            filterMap.set(filter.column.tableData.id, filter.value);
          });

          // Iterate over all columns to ensure each one is checked if the value is present in the filter map
          columnsWithFilter.forEach((col, columnId) => {
            const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

            // Update the filter state for each column
            handleFilterChange(columnId, newValue);
          });
        }}
        actions={[
          {
            tooltip: "Reset All Selected Error Orders",
            icon: () => (
              <Button variant="primary" size="small">
                Reset Orders
              </Button>
            ),
            onClick: (evt, data) => {
              setIsLoading(true);
              const reqObj = {
                errorOrderDto: data,
              };
              resetOrdersPostData(reqObj, getTableData, setIsLoading);
              resetOrdersPostData(reqObj).then((response) => {
                if (response.httpResponse === 200) {
                  setIsLoading(false);
                  getTableData();
                  toast.success(response.message);
                } else if (response.httpResponse === 406) {
                  setIsLoading(false);
                  toast.warn(response.message);
                } else {
                  setIsLoading(false);
                  toast.error(response.message);
                }
              });
            },
          },
        ]}
      />
    </ThemeProvider>
  );
};

export default ResetOrdersMaterialTable;
